import React, { Component, useReducer } from 'react';
import {Collapse,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import LoadingOverlay from 'react-loading-overlay'


  class CommunityPosts extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        community_posts: [],
        text: '',
        media: null,
        loading_overlay: false
      };
      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.UploadMedia = (e) => {
        this.setState({[e.target.name]: e.target.files[0]})
      }

      this.CreatePostRender = () => {
        const { cookies } = this.props;

        var token = cookies.get('token')
        if(token != null){
            return<LoadingOverlay
                active={this.state.loading_overlay}
                spinner
                text='Uploading your post...'
            >
                <div style={{textAlign: 'left'}}>
                Create post
                <Row>
                    <Col>
                        <Input name='text' type='text' value={this.state.text} style={{border: 'none', borderBottom: '1px solid silver', width: '100%'}}
                        onChange={this.HandleChange}/>
                    </Col>
                    <Col sm='2'>
                        <Input name='media' type='file' style={{width: '100%', border: 'none'}} onChange={this.UploadMedia}/>
                    </Col>
                </Row>
                <Button onClick={this.Post} style={{border: 'none', backgroundColor: '#1faced', width: '40%', borderRadius: '20px', marginTop: '20px'}}>
                    Post
                </Button>
                </div>
            </LoadingOverlay>
        }else{
            return<div></div>
        }
      }

      this.Post = () => {
          if((this.state.text == '') && (this.state.media == null)){
            alert('Post cannot be empty.')
          }else{
            this.setState({loading_overlay: true})
            const { cookies } = this.props;
      
            var data = new FormData()
            data.append('user_access_token', cookies.get('token'))
            data.append('text', this.state.text)
            data.append('media', this.state.media)
      
            axios.post(Backend_Url + 'createCommunityPosts', data)
            .then((res) => {
                let result = res.data
                this.setState({loading_overlay: false})
                alert('Post successful.')
                window.location.reload()
            }).catch((error) => {
                console.log(error)
                alert('Something went wrong, please try again.')
                this.setState({loading_overlay: false})
            })
          }
      }
    }

    componentDidMount() {
        const { cookies } = this.props;
  
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
  
        axios.post(Backend_Url + 'getAllCommunityPosts', data)
        .then((res) => {
            let result = res.data
            console.log(result)
            this.setState({community_posts: result})
        }).catch((error) => {
            console.log(error)
        })
    }




    render() {
        var community_posts = this.state.community_posts
        community_posts.sort((b, a) => a.date_posted.localeCompare(b.date_posted));
        var community_posts_map = community_posts.map((post, index) => {
            var post_type = post.post_type

            if(post_type == 'text'){
                return<Row style={{width: '50%', margin: '5px', marginBottom: '40px'}}>
                    <Col>
                    <p style={{textAlign: 'left', fontWeight: 'bold'}}>
                        <a href={'/user/' + post.user_id} style={{color: 'inherit'}}>
                            {post.user_name}
                        </a>
                    </p>
                    <br/>
                    <p style={{textAlign: 'left'}}>
                        {post.text}
                    </p>
                    <p style={{textAlign: 'left', fontSize: '12px'}}>
                        {post.date_posted}
                    </p>
                    </Col>
                </Row>
            }else if(post_type == 'image'){
                return<Row style={{width: '50%', margin: '5px', marginBottom: '40px'}}>
                    <Col>
                    <p style={{textAlign: 'left', fontWeight: 'bold'}}>
                        <a href={'/user/' + post.user_id} style={{color: 'inherit'}}>
                            {post.user_name}
                        </a>
                    </p>
                    <img src={Backend_Url + 'media/' + post.media} style={{width: '100%'}}/>
                    <br/><br/>
                    <p style={{textAlign: 'left'}}>
                        {post.text}
                    </p>
                    <p style={{textAlign: 'left', fontSize: '12px'}}>
                        {post.date_posted}
                    </p>
                    </Col>
                </Row>
            }else if(post_type == 'video'){
                return<Row style={{width: '50%', margin: '5px', marginBottom: '40px'}}>
                    <Col>
                    <p style={{textAlign: 'left', fontWeight: 'bold'}}>
                        <a href={'/user/' + post.user_id} style={{color: 'inherit'}}>
                            {post.user_name}
                        </a>
                    </p>
                    <video width="700" height="500" controls>
                        <source src={Backend_Url + 'media/' + post.media} type="video/mp4"/>
                        Your browser does not support the video tag.
                    </video>
                    <br/><br/>
                    <p style={{textAlign: 'left'}}>
                        {post.text}
                    </p>
                    <p style={{textAlign: 'left', fontSize: '12px'}}>
                        {post.date_posted}
                    </p>
                    </Col>
                </Row>
            }else{
                return<div>
                  <br/>
                  <Row>
                      <Col>
                          <h5 style={{marginTop: '60px', textAlign: 'center', marginBottom: '400px'}}>
                              Failed to load post.
                          </h5>
                      </Col>
                  </Row>
                </div>
            }
        })

        if(community_posts.length == 0){
          return<div>
            <this.CreatePostRender/>
            <br/>
            <Row>
                <Col>
                    <h5 style={{marginTop: '60px', textAlign: 'center', marginBottom: '400px'}}>
                        No posts found.
                    </h5>
                </Col>
            </Row>
          </div>
        }

      return (
        <div style={{minHeight: '550px'}}>
            <Helmet>
              <title>Community Posts - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <this.CreatePostRender/>
            <br/>
            <Container>
                {community_posts_map}
            </Container>
        </div>
      );
    }

  };
  
  export default withCookies(CommunityPosts);